import React, { ReactNode, useContext, useEffect, useState } from "react";
import { getAPIPath } from "../Domain";
import { useSignalRServiceV0 } from "./SignalRv0";
import { useSignalRServiceV1 } from "./SignalRv1";
import { HubConnection } from "@microsoft/signalr";


// 定義 ThemeContext 的類型
export interface SignalRToolContextType {
    connection: HubConnection | SignalR.Hub.Proxy | undefined;
    connectState: boolean;
}

// 創建Context對象，並使用undefined作為初始值
export const SignalRToolContext = React.createContext<SignalRToolContextType | undefined>(undefined);

// ThemeProvider 接受 ReactNode 子元素
export interface SignalRProviderProps {
    children: ReactNode;
}

// 創建一個Provider組件
export const SignalRProvider: React.FC<SignalRProviderProps> = ({ children }) => {
    const [connection, setConnection] = useState<HubConnection | SignalR.Hub.Proxy | undefined>(undefined);
    const [connectState, setConnectState] = useState<boolean>(false);

    const [apiPath, setApiPath] = useState<string | null>(null);

    const v0SignalRTool = useSignalRServiceV0({ url: apiPath ? `${apiPath?.slice(0, -1)}` : "" });
    const v1SignalRTool = useSignalRServiceV1({ url: apiPath ? `${apiPath}signalr` : "" });

    useEffect(() => {
        if (apiPath) {
            if (v0SignalRTool.connection || v1SignalRTool.connection) {

                console.log("v0SignalRTool: ", { connection: v0SignalRTool?.connection, connectState: v0SignalRTool.connectState });
                console.log("v1SignalRTool: ", { connection: v1SignalRTool?.connection, connectState: v1SignalRTool.connectState });

                const defaultApiVersion: string | null = localStorage.getItem("defaultApiVersion");
                if (defaultApiVersion === "framework") {
                    if (v0SignalRTool.connection) {
                        setConnection(v0SignalRTool.connection);
                        setConnectState(v0SignalRTool.connectState);
                    }
                } else {
                    if (v1SignalRTool.connection) {
                        setConnection(v1SignalRTool.connection);
                        setConnectState(v1SignalRTool.connectState);
                    }
                }
            }
        }
    }, [apiPath, v0SignalRTool.connection, v1SignalRTool.connection, v0SignalRTool.connectState, v1SignalRTool.connectState]);

    useEffect(() => {
        init();
    }, [])

    const init = async () => {
        try {
            const apiPath = await getAPIPath();
            setApiPath(apiPath);
        } catch (error) {
            console.error("Failed to initialize SignalR", error);
            // Optionally handle errors, e.g., by setting error state
        }
    }

    return (
        <SignalRToolContext.Provider value={{ connection, connectState }}>
            {children}
        </SignalRToolContext.Provider>
    );

};


// 自定義 Hook 來獲取 context，並添加錯誤處理以確保 context 不為 undefined
export const useSignalRTool = (): SignalRToolContextType => {
    const context = useContext(SignalRToolContext);
    if (context === undefined) {
        throw new Error('useSignalRTool must be used within a SignalRToolProvider');
    }
    return context;
};